import { render, staticRenderFns } from "./Leftmenu_kinder.vue?vue&type=template&id=f11316bc&scoped=true"
import script from "./Leftmenu_kinder.vue?vue&type=script&lang=js"
export * from "./Leftmenu_kinder.vue?vue&type=script&lang=js"
import style0 from "./Leftmenu_kinder.vue?vue&type=style&index=0&id=f11316bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11316bc",
  null
  
)

export default component.exports